export const usersListConstants = {
  CHARACTER: 'Character',
  DIGIT: 'Digit',
};

export const AMS_REPORTS_CONSTANTS = {
  CUSTOM_DATE_RANGE: 'custom_range',
  D365_REPORTS: 'D365-Reports',
  D365_MISSING_DATA_REPORTS: 'D365-Missing-Data-Reports',
  ACTIVITY_ENTRY_REPORT: 'activity-entry-report',
  ACTIVITY_CUTOFF_REPORT: 'activity-cutoff-report',
  ACTIVITY_NOT_ENTERED_REPORT: 'activity-not-entered-report',
  CHECK_INS: 'check-ins',
  ATTENDANCE_REPORT: 'attendance-report',
  BILLING_REPORT: 'billing-report',
  BILLING_HOURS_COMPARISON_REPORT: 'billing-hours-comparision-report',
  UNAPPROVED_ACTIVITIES: 'unapproved-activities',
  PAYROLL_REPORT: 'payroll-report',
  US_PAYROLL_REPORT: 'us-payroll-report',
  MZ_REPORT: 'mz-report',
  UTILIZATION_REPORT: 'utilization-report',
  ACTIVITY_MISMATCH_REPORT: 'activity-mismatch-report',
  UK_REPORTS: {
    BILLING_TRACKER: 'billing-tracker',
    MY_Uk_JOBS_BILLING_REPORT: 'my-uk-jobs-billing-report',
    STARTERS_AND_LEAVERS: 'starter-and-leavers',
    HOLIDAY_REPORT: 'holiday-report',
    SIDE_TURNOVER_REPORT: 'side-turnover-report',
    SALARY_BILL_REPORT: 'salary-bill-report',
    UK_PAYROLL_REPORT: 'payroll-report',
  },
};

export const REPORTS_CONSTANTS = {
  ACTIVITY_DETAILS_REPORT: 'activity-details-report',
  ATTENDANCE_MANAGEMENT_REPORT: 'attendance-management-report',
  PAID_LEAVE_ALERTS_REPORT: 'paid-leave-alerts-report',
  ATTENDANCE_DATA_REPORT: 'attendance-data-report',
  PAID_DAYS_REPORT: 'paid-days-report',
};

export const USER_ACCESS_SCHEMA = {
  ESS: {
    REPORTS: 'Reports',
    HIERARCHY: 'Hierarchy',
    PROFILE: 'Profile',
    GROUPS: 'Groups',
    DEPARTMENT: 'Department',
    HOLIDAYS: 'Holidays',
    LEAVES: 'Leaves',
    ATTENDANCE_SHIFT: {
      NCNS: 'NCNS',
      SHIFT: 'Shift',
      TIMESHEET: 'Timesheet',
    },
    ACTIVITY: 'Activity',
    SCHEDULES: 'Schedules',
    PROBATION_DETAILS: 'Probation Details',
  },
  SETTINGS: {
    BRANCHES: 'Branches',
    COMPANY_INFORMATION: {
      NEW_FIELDS: 'New Fields',
      BASICS: 'Basics',
    },
  },
  LMS: {
    LEAVE_MASTER: {
      UPCOMING_LEAVES: 'Upcoming Leaves',
      APPROVED_LEAVES: 'Approved Leaves',
      REJECTED_LEAVES: 'Rejected Leaves',
      APPLY_ON_BEHALF: 'Apply on Behalf',
      LEAVES_REQUESTED: 'Leaves Requested',
    },
  },
  UMS: {
    REQUESTS: {},
    USERS: {
      CONTRACT_TYPES: 'Contract Types',
      USER_PROFILE: 'User Profile',
      EMPLOYEE_ID_SETUP: 'Employee ID Setup',
      BULK_UPDATE: 'Bulk Update',
      DEACTIVATE_ACTIVATE: 'Deactivate/Activate',
      IMPORT: 'Import',
      CREATE_NEW: 'Create New',
      OFF_BORAD_EMPLOYEE: 'Off-Board Employee',
      LEAVE_OF_ABSENCE: 'Leave Of Absence',
      NEW_FIELDS: 'New Fields',
      UPDATE_EMPLOYEE_ID: 'Update Employee ID',
    },
    GROUPS: {
      MANAGE_GROUP_TYPES: 'Manage Group Types',
    },
    HIERARCHY: {
      MANAGE_DESIGNATIONS: 'Manage Designations',
    },
    ASSET_MANAGEMENT: {
      HARDWARE: 'Hardware',
      SOFTWARE: 'Software',
    },
    SKILL_MANAGEMENT: {
      SKILLS: 'Skills',
      CATEGORY: 'Category',
    },
    REPORTS: {
      UMS_REPORT_USER_MASTERS: 'User Masters Report',
    },
  },
};

export const __AWL_SEPERATOR__ = '__AWL_SEPERATOR__';
export const RECORDS_PER_PAGE =
  window?.innerHeight > 2560
    ? 60
    : window?.innerHeight > 2160
    ? 45
    : window?.innerHeight > 1080
    ? 30
    : 15;

export const activityStatus = {
  approved: 'Approved',
  rejected: 'Rejected',
  pending: 'Pending',
  approve: 'approve',
  reject: 'reject',
};
export const CUSTOM_DATE_RANGE = 'custom_range';

export const FEEDBACK_FIELD_TYPES = [
  {label: 'Small Text', value: 'text'},
  {label: 'Large Text', value: 'textarea'},
  {label: 'Multi Choices', value: 'checkbox'},
  {label: 'Single Choice', value: 'radio'},
  {label: 'Rating', value: 'ratings'},
];

export const FIELD_TYPES = [
  {label: 'Small Text', value: 'text'},
  {label: 'Large Text', value: 'textarea'},
  {label: 'Dropdown', value: 'dropdown'},
  {label: 'Date', value: 'date'},
  {label: 'Multi Choices', value: 'checkbox'},
  {label: 'Single Choice', value: 'radio'},
  {label: 'Switch (Yes/No)', value: 'switch'},
  {label: 'File Upload', value: 'file'},
];

export const candidatePortalJobListPageLink =
  process.env.REACT_APP_CANDIDATE_PORTAL_URL + 'job-openings-detail/';

export const HRMS_DYNAMIC_VISIBLE_8_TABS = 8;
export const HRMS_DYNAMIC_VISIBLE_4_TABS = 4;
export const THEMES = {
  DEFAULT: 'default',
  LIGHT: 'light',
  DARK: 'dark',
  COMPACT: 'compact',
};

export const PrimaryOptions = [
  // {label: 'Better Prospects', value: 'Better Prospects'},
  // {label: 'Higher Education', value: 'Higher Education'},
  // {label: 'Personal Reason', value: 'Personal Reason'},
  // {label: 'Health Issue', value: 'Health Issue'},
  // {label: 'NCNS - Abscond', value: 'NCNS - Abscond'},
  // {label: 'BGV Discrepancy', value: 'BGV Discrepancy'},
  // {label: 'Code of Conduct', value: 'Code of Conduct'},
  // {label: 'Performance Issues', value: 'Performance Issues'},
  // {label: 'Exit without Pay & Papers', value: 'Exit without Pay & Papers'},
  // {label: 'Training Dropout', value: 'Training Dropout'},
  {label: 'Resignation', value: 'Resignation'},
  {label: 'Termination', value: 'Termination'},
  {label: 'Demise', value: 'Demise'},
  {label: 'Others', value: 'Others'},
];

export const SecondaryOptions = [
  {label: 'Compensation', value: 'Compensation'},
  {label: 'Change in Job Profile', value: 'Change in Job Profile'},
  {label: 'Work environment', value: 'Work environment'},
  {label: 'Work pressure', value: 'Work pressure'},
  {label: 'Work from office', value: 'Work from office'},
  {label: 'Family Business', value: 'Family Business'},
  {label: 'Relocation', value: 'Relocation'},
  {label: 'Marriage', value: 'Marriage'},
  {label: 'Health Issue - Employee', value: 'Health Issue - Employee'},
  {
    label: 'Health Issue - Family Member',
    value: 'Health Issue - Family Member',
  },
  {label: 'Shift Timing Issue', value: 'Shift Timing Issue'},
  {label: 'Higher Education', value: 'Higher Education'},
  {label: 'Exams', value: 'Exams'},
];

export const ResignationReasons = [
  {label: 'New Opportunity', value: 'New Opportunity'},
  {label: 'Relocation', value: 'Relocation'},
  {label: 'Study', value: 'Study'},
  {label: 'Better prospects', value: 'Better prospects'},
  {label: 'Other', value: 'Other'},
];
export const TerminationReasons = [
  {label: 'Conduct', value: 'Conduct'},
  {label: 'NCNS/AWOL', value: 'NCNS/AWOL'},
  {label: 'Capability', value: 'Capability'},
  {label: 'Redundancy', value: 'Redundancy'},
  {label: 'Capability (Health)', value: 'Capability(Health)'},
  {label: 'End of Contract', value: 'End of Contract'},
  {label: 'Failed Probation', value: 'Failed Probation'},
  {label: 'Legal Reason', value: 'Legal Reason'},
  {label: 'Infosec Breach as a reason', value: 'Infosec Breach as a reason'},
  {label: 'Other', value: 'Other'},
];

export const languageSelectOptions = [
  {label: 'English', value: 'English', backendHeaderCode: 'en'},
  {label: 'Romanian (Română)', value: 'Romanian', backendHeaderCode: 'ro'},
  {label: 'Japanese (日本語)', value: 'Japanese', backendHeaderCode: 'ja'},
  {label: 'Korean (한국어)', value: 'Korean', backendHeaderCode: 'ko'},
  {
    label: 'Simplified Chinese (中文简体字)',
    value: 'Simplified Chinese',
    backendHeaderCode: 'sc',
  },
  {
    label: 'Traditional Chinese (中文繁體字)',
    value: 'Traditional Chinese',
    backendHeaderCode: 'tc',
  },
  {
    label: 'Canadian French (Français Canadien)',
    value: 'Canadian French',
    backendHeaderCode: 'fr',
  },
  {
    label: 'Russian (русский)',
    value: 'Russian',
    backendHeaderCode: 'ru',
  },
];

export const HRMS_CONSTANTS = {
  FILE: 'file',
  TEXT: 'text',
  DATE: 'date',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
};

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

export const PHONE_NUMBER_REGX =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const EMPTY_HOUR_MINUTE_LIST = ['00:00', '0:0', '0:00', '00:0'];

export const monthOptions = [
  {value: 1, label: 'January'},
  {value: 2, label: 'February'},
  {value: 3, label: 'March'},
  {value: 4, label: 'April'},
  {value: 5, label: 'May'},
  {value: 6, label: 'June'},
  {value: 7, label: 'July'},
  {value: 8, label: 'August'},
  {value: 9, label: 'September'},
  {value: 10, label: 'October'},
  {value: 11, label: 'November'},
  {value: 12, label: 'December'},
];

export const shortMonthTitles = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'Aug',
  September: 'Sept',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec',
};

export const NUMBER_REGX = /^[0-9]*(\.[0-9]{0,2})?$/;

export const monthDaysOptions = [
  {label: '1st', value: 1},
  {label: '2nd', value: 2},
  {label: '3rd', value: 3},
  {label: '4th', value: 4},
  {label: '5th', value: 5},
  {label: '6th', value: 6},
  {label: '7th', value: 7},
  {label: '8th', value: 8},
  {label: '9th', value: 9},
  {label: '10th', value: 10},
  {label: '11th', value: 11},
  {label: '12th', value: 12},
  {label: '13th', value: 13},
  {label: '14th', value: 14},
  {label: '15th', value: 15},
  {label: '16th', value: 16},
  {label: '17th', value: 17},
  {label: '18th', value: 18},
  {label: '19th', value: 19},
  {label: '20th', value: 20},
  {label: '21st', value: 21},
  {label: '22nd', value: 22},
  {label: '23rd', value: 23},
  {label: '24th', value: 24},
  {label: '25th', value: 25},
  {label: '26th', value: 26},
  {label: '27th', value: 27},
  {label: '28th', value: 28},
  // {label: '29th', value: 29},
  // {label: '30th', value: 30},
  // {label: '31st', value: 31},
];

export const countOptions = {
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: '4th',
  5: '5th',
  6: '6th',
  7: '7th',
  8: '8th',
  9: '9th',
  10: '10th',
  11: '11th',
  12: '12th',
  13: '13th',
  14: '14th',
  15: '15th',
  16: '16th',
  17: '17th',
  18: '18th',
  19: '19th',
  20: '20th',
  21: '21st',
  22: '22nd',
  23: '23rd',
  24: '24th',
  25: '25th',
  26: '26th',
  27: '27th',
  28: '28th',
  // 29: '29th',
  // 30: '30th',
  // 31: '31st',
};
